import VisitList from "../visits/VisitList";

const IPDVisits = () => {
  return <VisitList type="ipd" />;
};

export default IPDVisits;
